'use strict'
import { ref } from 'vue'
import { User, Module } from '@/js/model'

const isSFBForStudiengang = ref(false)
const isSDForFachbereich = ref(false)

export function useModuleAccess() {
    const moduleToVote = ref<Module>({})
    const isLehrenderForModule = ref<boolean | undefined>(undefined)
    const isModulverantwortlicherForModule = ref<boolean | undefined>(undefined)

    const checkIsLehrender = (user: User) =>
        moduleToVote.value.lehrende.some((lehrendeId: string) => lehrendeId === user.userId)
    const checkIsModulverantwortlicher = (user: User) =>
        moduleToVote.value.modulverantwortliche.some((lehrendeId) => lehrendeId === user.userId)

    const checkIsSFBForStudiengang = (user: User, studiengangId: string | undefined) => {
        return (
            'Studienfachberater(in)' in user.rollen &&
            user.rollen['Studienfachberater(in)']?.studiengangIds.some(
                (rollenId: string) => rollenId === studiengangId
            )
        )
    }
    const checkIsSDForFachbereich = (user: User, fachbereichId: string | undefined) => {
        return (
            'Studiendekan' in user.rollen &&
            user.rollen['Studiendekan']?.fachbereichIds.some(
                (rollenId) => rollenId === fachbereichId
            )
        )
    }

    const updateModuleAccess = (module: Module, currentUser: User) => {
        moduleToVote.value = module
        isLehrenderForModule.value = checkIsLehrender(currentUser)
        isModulverantwortlicherForModule.value = checkIsModulverantwortlicher(currentUser)
    }

    const updateStudiengangAccess = (studiengangId: string, currentUser: User) => {
        isSFBForStudiengang.value = checkIsSFBForStudiengang(currentUser, studiengangId)
    }

    const updateFachbereichAccess = (fachbereichId, currentUser) => {
        isSDForFachbereich.value = checkIsSDForFachbereich(currentUser, fachbereichId)
    }

    return {
        updateFachbereichAccess,
        updateStudiengangAccess,
        updateModuleAccess,
        isLehrenderForModule,
        isModulverantwortlicherForModule,
        isSFBForStudiengang,
        isSDForFachbereich
    }
}
